module.exports = __webpack_public_path__ + "img/sjxxrs.9ddb23c3.png";